/**
 * 路由表：/login /register 公开；其余经 RequireAuth（未登录跳 /login）。
 */
import { Navigate, Route, Routes } from 'react-router-dom';
import { RequireAuth } from './components/AppShell';
import { useAuth } from './stores/auth';
import { LoginPage } from './pages/Login';
import { RegisterPage } from './pages/Register';
import { DashboardPage } from './pages/Dashboard';
import { TasksPage } from './pages/Tasks';
import { ProjectsPage } from './pages/Projects';
import { HabitsPage } from './pages/Habits';
import { FocusPage } from './pages/Focus';
import { StatsPage } from './pages/Stats';
import { ContactsPage } from './pages/Contacts';
import { ContactDetailPage } from './pages/ContactDetail';
import { VaultPage } from './pages/Vault';
import { SettingsPage } from './pages/Settings';
import { NotFoundPage } from './pages/NotFound';

/** 已登录访问登录/注册页时重定向首页 */
function GuestOnly({ children }: { children: JSX.Element }) {
  const status = useAuth((s) => s.status);
  if (status === 'authed') return <Navigate to="/" replace />;
  return children;
}

export function App() {
  return (
    <Routes>
      <Route
        path="/login"
        element={
          <GuestOnly>
            <LoginPage />
          </GuestOnly>
        }
      />
      <Route
        path="/register"
        element={
          <GuestOnly>
            <RegisterPage />
          </GuestOnly>
        }
      />
      <Route element={<RequireAuth />}>
        <Route index element={<DashboardPage />} />
        <Route path="/tasks" element={<TasksPage />} />
        <Route path="/projects" element={<ProjectsPage />} />
        <Route path="/habits" element={<HabitsPage />} />
        <Route path="/focus" element={<FocusPage />} />
        <Route path="/stats" element={<StatsPage />} />
        <Route path="/contacts" element={<ContactsPage />} />
        <Route path="/contacts/:id" element={<ContactDetailPage />} />
        <Route path="/vault" element={<VaultPage />} />
        <Route path="/settings" element={<SettingsPage />} />
      </Route>
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
